import React, { useState, useRef } from "react";
import TimeInputs from "globalComponents/TimeInputs";
import DurationInput from "./DurationInput";
import EndOfDayButton from "./EndOfDayButton";
import ClockIconSmall from "icons/ClockIconSmall";

export default function TimeRow(props) {
  const {
    itemTime,
    setItemTime,
    appointmentDuration,
    setAppointmentDuration,
    itemType,
  } = props;
  const [hasFocus, setHasFocus] = useState(false);
  const hourRef = useRef(null);

  const timeTextClass = itemType === "task" ? "deadline" : "time";

  function timeTextSubscript() {
    if (itemType === "task") {
      return "Deadline";
    } else {
      return "Time";
    }
  }

  function handleTimeBlur() {
    if (hasFocus) {
      setHasFocus(false);
    }
  }

  function handleTimeFocus(event) {
    const id = event.target.id;
    const isInput = id.split("-")[1] === "input";
    console.log("id", id, isInput, hasFocus);
    if (!hasFocus) {
      if (!isInput) {
        if (hourRef.current) {
          hourRef.current.select();
        }
      }
      setHasFocus(true);
    }
  }

  return (
    <div className="Time-row item-view-row" onClick={handleTimeFocus}>
      <div className="flex-center-div left-side-icon">
        <ClockIconSmall />
      </div>
      <div className="time-text-container">
        <span className={"time-text " + timeTextClass} onBlur={handleTimeBlur}>
          <TimeInputs
            itemTime={itemTime}
            setItemTime={setItemTime}
            hasFocus={hasFocus}
            setHasFocus={setHasFocus}
            handleTimeFocus={handleTimeFocus}
            hourRef={hourRef}
            timeTextClass={timeTextClass}
          />
        </span>
        <span className="time-text-subscript subscript">
          {timeTextSubscript()}
        </span>
        {hasFocus && itemType === "task" && (
          <EndOfDayButton setHasFocus={setHasFocus} setItemTime={setItemTime} />
        )}
      </div>
      {itemType === "appointment" && (
        <DurationInput
          itemDuration={appointmentDuration}
          setItemDuration={setAppointmentDuration}
        />
      )}
    </div>
  );
}
